import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csharpsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";

function Csloping(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>
      <Helmet>
 
 <title>C# Looping Statement tutorial For Beginners</title>
 <meta name="description" content="C# Looping Statement tutorial for beginners.Looping Statement in C# is used to repeat a particular piece of cards until the given condition is false. Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,C# Looping Statement,c# Looping Statement for,c sharp Looping Statement,c# Looping Statement for loop,end for loop c#,C# looping Statement Types" />
 <link rel="canonical" href="https://www.codeexampler.com/csharp-looping-statement" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">C# Looping Statement</h1>
    <div className="first">
        <a href="/csharp-switch">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-while">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para">Looping statement in c#
is used to repeat a particular piece of cards until the given condition is false.
</p>
<h2 className="mt-4 mh2">There are 3 Types of Looping Statement in c# programming:
</h2>
<h3 className="mt-4 mh3">1, Using a while loop in c# statement<br/>
2, Using  a do-while looping in c# statement<br/>
3, Using a for looping in c# <br/>

</h3>
<h2 className="mt-4 mh2">1, while loop in c#:</h2>
<p className="mt-4 para">In a while loop for c#, a condition will be given and the body of the loop is executed until that the condition is false.
</p>

<h2 className='headings'>While loop C# Syntax:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}{"\n"}
            <span className="qwerty-3">while </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-4">condition</span>
            <span className="qwerty-7">)</span>
            {"\n"}
            <span className="qwerty-2">&#123; </span>
            {"\n"}
            <span className="qwerty-1">- </span>
            {"\n"}
            <span className="qwerty-6">statement </span>
            {"\n"}
            <span className="qwerty-1">- </span>
            {"\n"}
            <span className="qwerty-2">&#123; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>



<h2 className="mt-4 mh2">2,Do-while loop:</h2>
<p className="mt-4 para">In the do-while loop a condition will be given and that will be checked after the execution of the body of the loop.
</p>


<h2 className='headings'>Do-While loop C# Syntax:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}{"\n"}
            <span className="qwerty-5">do </span>
            <span className="qwerty-2">&#123; </span>
               {"\n"}
            <span className="qwerty-6">Statement </span>
            {"\n"}
            <span className="qwerty-6">Statement </span>
            {"\n"}
            <span className="qwerty-1">- </span>
            {"\n"}
            <span className="qwerty-2">&#125; </span>
            {"\n"}
            <span className="qwerty-3">while </span>
            <span className="qwerty-7">(</span>
            <span className="qwerty-4">condition</span>
            <span className="qwerty-7">)</span>

            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

    
<h2 className="mt-4 mh2">3, For loop C#:</h2>
<p className="mt-4 para">1, In the for loop c#, the body of the loop will be executed until the given condition is false<br/>
2, This for loop is used to repeat a particular piece of code for a fixed no of times<br/>
3, In the for loop CSharp(C#) there are two semicolons must be used<br/>
</p>


<h2 className='headings'>For loop C# Syntax:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code>{"\n"}{"\n"}
            <span className="qwerty-5">for </span>
            <span className="qwerty-2">(</span>
            <span className="qwerty-6">statement</span>
            <span className="qwerty-6">; </span>
            <span className="qwerty-1">condition</span>
            <span className="qwerty-2">;</span>
            <span className="qwerty-6">statement</span>
            <span className="qwerty-1">)</span>
            {"\n"}
            <span className="qwerty-6">Statement</span>
            <span className="qwerty-6">; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>


  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/csharp-switch">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/csharp-while">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csloping;